import * as Scrivito from "scrivito";

const RecentProjectsWidget = Scrivito.provideWidgetClass(
  "RecentProjectsWidget",
  {
    attributes: {
      leftLinks: ["widgetlist", { only: "RecentProjectsLinkWidget" }],
      rightLinks: ["widgetlist", { only: "RecentProjectsLinkWidget" }],
      btnText: "string",
      sideToShow: ["enum", { values: ["left", "both", "right"] }],
      listTitle: "string",
      projectCountSingle: "string",
      projectCountPlural: "string",
      redirectToProjectCreate: ["reference", { only: "ProjectConfigurator" }],
      redirectToProjectItem: ["reference", { only: "ProjectItem" }],
    },
    extractTextAttributes: ["btnText", "listTitle"],
  },
);

export default RecentProjectsWidget;
